import React from "react";
import {FilterButton, FilterButtonProps} from "react-admin";
import styles from './CustomFilterButton.module.css';

const CustomFilterButton = (props: FilterButtonProps) => <FilterButton {...props} className={styles.root}/>

export default CustomFilterButton;